/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Locked_BannerInputs */



/**
* | output |
* | --- |
* | "Another device is running this tournament offline. Updates resume when it's back online." |
*
* @param {Offline_Locked_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_locked_banner = /** @type {((inputs?: Offline_Locked_BannerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Locked_BannerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un autre appareil gère ce tournoi hors ligne. Les mises à jour reprendront à son retour en ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Otro dispositivo gestiona este torneo sin conexión. Las actualizaciones seguirán cuando vuelva a estar en línea.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Outro dispositivo está gerenciando este torneio offline. As atualizações voltam quando ele ficar online.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un altro dispositivo gestisce questo torneo offline. Gli aggiornamenti riprendono quando torna online.")
	return /** @type {LocalizedString} */ ("Another device is running this tournament offline. Updates resume when it's back online.")
});